/**
 * @fileoverview Bulk-edit target helper (MOR-707)
 *
 * Split out of `bulk-edit-tasks-dialog.tsx` (react-refresh/only-export-components)
 * — pure conversion from a selected `CalendarEventRow` to the target shape
 * `tasks.mutations.bulkUpdateTasks` expects.
 */

import type { Id } from "@cvx/_generated/dataModel";
import type { CalendarEventRow } from "@/calendar/eventAdapter";

/** Bulk targets are built from the selected rows by the hosting surface. */
export interface BulkTaskTarget {
  id?: Id<"jobKeyDates">;
  jobId?: Id<"jobs">;
  code?: string;
}

export function targetForRow(row: CalendarEventRow): BulkTaskTarget | null {
  if (row.persistedId) return { id: row.persistedId };
  if (row.code) return { jobId: row.jobId, code: row.code };
  return null;
}
